import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  openModal,
  closeModal,
} from "../../../store/slices/editModalUsersSlice";
import { FaPencilAlt } from "react-icons/fa";
import { FaRegCircleXmark } from "react-icons/fa6";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  fetchDataUsers,
  updateDataUsers,
} from "../../../store/slices/authSlice";
import edit from "../../../assets/edit.png";

const EditModalUsers = ({ id, title }) => {
  const dispatch = useDispatch();
  const dataExams = useSelector((state) => state.auth.data);
  const isOpen = useSelector((state) => state.editModalUsers[id] === true);

  const [password, setPassword] = useState("");

  useEffect(() => {
    dispatch(fetchDataUsers());
  }, []);

  const handleOpenModal = () => {
    dispatch(openModal(id));
  };

  const handleCloseModal = () => {
    dispatch(closeModal(id));
  };

  const handleEditItem = async (e) => {
    e.preventDefault();
    const updatedData = {
      password,
    };

    try {
      dispatch(updateDataUsers({ id: id, updatedData }));
      toast.success("Te dhenat jan ruajtur me sukses!");
      handleCloseModal();
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div>
      <button onClick={handleOpenModal}>
        <FaPencilAlt style={{ width: 20, height: 20 }} />
      </button>

      {isOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-2 sm:p-4">
          <div className="bg-black bg-opacity-40 absolute inset-0"></div>

          <div className="relative w-full max-w-sm sm:max-w-md bg-white dark:bg-gray-800 rounded-xl shadow-lg z-10 overflow-hidden">
            <button
              type="button"
              onClick={handleCloseModal}
              className="absolute top-3 right-3 text-gray-400 hover:text-gray-700 dark:hover:text-white hover:bg-gray-100 dark:hover:bg-gray-700 rounded-full w-8 h-8 flex justify-center items-center"
            >
              <FaRegCircleXmark className="w-5 h-5" />
            </button>

            <div className="p-5 sm:p-6 text-center">
              <h3 className="mb-4 text-lg font-semibold text-gray-700 dark:text-gray-300">
                {title}
              </h3>

              <form className="space-y-5 text-start" onSubmit={handleEditItem}>
                <div>
                  <label
                    htmlFor="password"
                    className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                  >
                    Password:
                  </label>
                  <input
                    type="password"
                    name="password"
                    id="password"
                    className="w-full p-2.5 text-sm rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 bg-gray-50 text-gray-900 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                    placeholder=""
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                  />
                </div>

                <div className="flex flex-col sm:flex-row justify-center items-center gap-3 pt-2">
                  <button
                    type="submit"
                    className="w-full sm:w-auto px-5 py-2.5 text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 rounded-lg focus:ring-4 focus:outline-none focus:ring-blue-300 dark:bg-blue-700 dark:hover:bg-blue-600 dark:focus:ring-blue-500"
                  >
                    Ndrysho Passwordin
                  </button>

                  <button
                    type="button"
                    onClick={handleCloseModal}
                    className="w-full sm:w-auto px-5 py-2.5 text-sm font-medium text-gray-700 bg-white border border-gray-300 hover:bg-gray-100 hover:text-black rounded-lg focus:ring-4 focus:outline-none focus:ring-gray-300 dark:bg-gray-600 dark:text-gray-300 dark:border-gray-500 dark:hover:bg-gray-700 dark:hover:text-white dark:focus:ring-gray-500"
                  >
                    Anulo
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default EditModalUsers;
